import script from "./CategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryModal.vue?vue&type=style&index=0&id=507924e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507924e4"]])

export default __exports__